export default (
  state = () => {
    throw new Error('Refetch is not defined');
  },
  action
) => {
  switch (action.type) {
    case 'SET_REFETCH':
      return action.refetch;
    default:
      return state;
  }
};
